<template>
  <div class="order-opoup-container van-overlay" style="z-index: 99;" v-if="show">
    <div class="inner-container">
      <div class="popup-title-item">
        <div class="title">订单详情</div>
        <div class="close-btn img-cover" @click="handleClose"><img src="../../assets/pc-images/close-icon.png" /></div>
      </div>
      <div class="popup-content-container">
        <div class="info-list-item">
          <div class="pate-title">商品信息</div>
          <el-descriptions class="info-item" :column="2" size="mini" border>
            <el-descriptions-item label="商品名称">{{ orderInfo.GoodsName }}</el-descriptions-item>
            <el-descriptions-item label="商品单价">¥ {{ Math.round(orderInfo.SellingPrice * 100000) / 100000 }}</el-descriptions-item>
            <el-descriptions-item label="购买数量">{{ orderInfo.BuyNumber }}</el-descriptions-item>
            <el-descriptions-item label="实付款">{{ Math.round(orderInfo.Amount * 100000) / 100000  }}</el-descriptions-item>
            <el-descriptions-item label="进度" :span="2">
              <div class="count-item">
                <div class="item">开始 {{ orderInfo.StartNum }}</div>·
                <div class="item">当前 {{ orderInfo.CurrentNum }}</div>·
                <div class="item">完成 {{ orderInfo.CurrentNum - orderInfo.StartNum }}</div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="info-list-item">
          <div class="pate-title">订单参数</div>
          <el-descriptions class="info-item" :column="1" size="mini" border>
            <el-descriptions-item :label="item.name" v-for="(item, index) in orderInfo.BuyParams" :key="index" labelClassName="params-label-item">
              <div v-if="item.type == 9" class="img-cover" style="width: 120px;height: 120px;"><img :src="item.value"></div>
              <div v-else class="detail">{{ item.value }} <span class="btn" @click="handleCopy(item.value)">复制</span></div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="info-list-item">
          <div class="pate-title">订单信息</div>
          <el-descriptions class="info-item" :column="2" size="mini" border>
            <el-descriptions-item label="订单ID">{{ orderInfo.Id }} <span class="btn" @click="handleCopy(orderInfo.Id)">复制</span></el-descriptions-item>
            <el-descriptions-item label="订单状态">{{ orderStatusObj[orderInfo.OrderStatus] }}</el-descriptions-item>
            <el-descriptions-item label="订单编号">{{ orderInfo.OrderSN }} <span class="btn" @click="handleCopy(orderInfo.OrderSN)">复制</span></el-descriptions-item>
            <el-descriptions-item label="下单时间">{{ $TOOL.dateFormat(orderInfo.CreateAt * 1000, 'yyyy-MM-dd hh:mm') }}</el-descriptions-item>
            <el-descriptions-item label="退款金额" v-if="parseInt(orderInfo.RefundAmount)">{{ orderInfo.RefundAmount }}</el-descriptions-item>
            <el-descriptions-item label="退款数量" v-if="parseInt(orderInfo.RefundNumber)">{{ orderInfo.RefundNumber }}</el-descriptions-item>
            <el-descriptions-item label="退款原因" v-if="orderInfo.BackReason" :span="2">{{ orderInfo.BackReason }}</el-descriptions-item>
            <el-descriptions-item label="订单备注" v-if="orderInfo.OrderRemark" :span="2">{{ orderInfo.OrderRemark }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div v-if="orderInfo.CardCodeIds && orderInfo.CardCodeIds.length > 0" class="info-list-item">
          <div class="pate-title">卡密信息</div>
          <el-descriptions class="info-item" :column="1" size="mini" border>
            <el-descriptions-item label="卡密" v-for="(item, index) in orderInfo.CardCodeIds" :key="index" labelClassName="params-label-item">
              {{ item }} <span class="btn" @click="handleCopy(item)">复制</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div v-if="orderInfo.Logs && orderInfo.Logs.length > 0" class="info-list-item">
          <div class="pate-title">订单记录</div>
          <el-descriptions class="info-item" :column="1" size="mini" border>
            <el-descriptions-item :label="item.content" v-for="(item, index) in orderInfo.Logs" :key="index">{{ item.createdAt }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  emits: ['close'],
  name: "OrderDetailComponent",
  data() {
    return {
      show: false,
      id: '',
      orderInfo: {},
      orderStatusObj: { '-1': '待付款', '1': '已付款', '2': '处理中', '3': '异常', '4': '已完成', '5': '退单中', '6': '已退单', '7': '已退款', '8': '待处理' },
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  watch: {
    
  },
  methods: {
    open(id) {
      this.id = id
      this.show = true
      this.handleGetOrder()
    },
    handleClose() {
      this.show = false
      this.$emits('close')
    },
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    async handleGetOrder() {
      const { id } = this
      var res = await this.$API.orderDetail.post({
        Id: id
      })
      if (res.error == 0) {
        res.info.Logs = JSON.parse(res.info.Logs || '[]')
        res.info.BuyParams = JSON.parse(res.info.BuyParams || '[]')
        res.info.CardCodeIds = res.info.CardCodeIds.split(',')
        res.info.CardCodeIds = res.info.CardCodeIds.filter(item => item != '')
        this.orderInfo = res.info
      }
    }
  },
}
</script>

<style lang="less" scoped>
.inner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 706px;
  min-height: 565px;
  background-color: #fff;
  border-radius: 5px;
  transform: translate(-50%, -50%);
  .popup-title-item {
    margin: 0 15px;
    position: relative;
    height: 58px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #393942;
    }
    .close-btn {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .popup-content-container {
    max-height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
    word-break: break-all;
    padding: 0 15px 15px;
    .pate-title {
      height: 25px;
      line-height: 25px;
      padding-left: 18px;
      color: #393942;
      font-size: 18px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 25px;
        border-radius: 2px;
        background-color: #5783fc;
      }
    }
    .info-list-item {
      padding: 20px 0;
      border-bottom: 1px solid #e5e5e5;
      .info-item {
        margin-top: 18px;
      }
      .btn {
        cursor: pointer;
        color: #5783fc;
        margin-left: 6px;
      }
      .count-item {
        display: flex;
        align-items: center;
        color: #151d2b;
        .item {
          font-size: 12px;
          margin: 0 3px;
        }
      }
      /deep/.params-label-item {
        width: 148px !important;
      }
    }
  }
}
</style>